import { useAppContext } from "@/appContext";
import { cn } from "@/utils/utils";
import { UserRound } from "lucide-react";
import { FC } from "react";

// Define the Props interface for the component
interface Props {
  isAI: boolean;
  text: string;
}

// Define the TranscriptChat functional component
const TranscriptChat: FC<Props> = ({ isAI, text }) => {
  // Extract state from the app context
  const { state } = useAppContext();
  const { profileUser } = state;

  // Initialize nameString variable
  let nameString;
  try {
    // If profileUser exists, create initials from the user's name
    nameString = profileUser ? `${profileUser.name.split(' ')[0].at(0)}${profileUser.name.split(' ')[1].at(0)}` : "You";
  } catch {
    // Default to "You" if an error occurs
    nameString = "You";
  }

  return (
    // Container div for the chat message
    <div className="flex gap-4 justify-center items-center pr-[24px]">
      <div
        className={cn(
          // Apply conditional styling based on whether the message is from AI or not
          "flex rounded-full min-w-[33px] min-h-[31px] justify-center items-center border",
          isAI ? "bg-[#FFCB7C]" : "bg-white"
        )}
      >
        {isAI ? (
          // Display AI icon if the message is from AI
          <UserRound />
        ) : (
          // Display user initials if the message is from the user
          nameString.toUpperCase()
        )}
      </div>
      {/* Display the chat message text */}
      <p className="p-0 m-0">{text}</p>
    </div>
  );
};

export default TranscriptChat;
